module.exports = __webpack_public_path__ + "static/img/sub04_1.4daf341.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sub/sub04_1.png
// module id = W2Oi
// module chunks = 1